<template>
  <span class="IconBase">
    <component :is="iconName" />
  </span>
</template>

<script setup lang="ts">
import AppIcon from './icons/AppIcon.vue';
import CheckCircleIcon from './icons/CheckCircleIcon.vue';
import CloseIcon from './icons/CloseIcon.vue';
import DownIcon from './icons/DownIcon.vue';
import EditIcon from './icons/EditIcon.vue';
import ErrorIcon from './icons/ErrorIcon.vue';
import OtherIcon from './icons/OtherIcon.vue';
import PasswordOffIcon from './icons/PasswordOffIcon.vue';
import PasswordOnIcon from './icons/PasswordOnIcon.vue';
import ServiceIcon from './icons/ServiceIcon.vue';
import SuccessIcon from './icons/SuccessIcon.vue';
import UpIcon from './icons/UpIcon.vue';
import UserIcon from './icons/UserIcon.vue';
import ExceptionIcon from './icons/ExceptionIcon.vue';
import DoubleLeftIcon from './icons/DoubleLeftIcon.vue';
import DoubleRightIcon from './icons/DoubleRightIcon.vue';

defineOptions({
  name: 'IconBase',
  // Local registration so the dynamic <component :is="iconName"> string lookup resolves
  components: {
    App: AppIcon,
    CheckCircle: CheckCircleIcon,
    Close: CloseIcon,
    Down: DownIcon,
    Edit: EditIcon,
    Error: ErrorIcon,
    Other: OtherIcon,
    PasswordOff: PasswordOffIcon,
    PasswordOn: PasswordOnIcon,
    Service: ServiceIcon,
    Success: SuccessIcon,
    Up: UpIcon,
    User: UserIcon,
    Exception: ExceptionIcon,
    DoubleLeft: DoubleLeftIcon,
    DoubleRight: DoubleRightIcon,
  },
});

defineProps<{
  iconName: string;
}>();
</script>

<style lang="scss" scoped>
.IconBase {
  display: inline-flex;
}
</style>
